<template>
  <div class="wrapper">
    <van-button round
      icon="location-o"
      size="small"
      color="rgba(255, 255, 255, 0.15)"
      @click="showPicker = true">{{ currentArea }}</van-button>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="areaList"
        @cancel="showPicker = false"
        @confirm="handleAreaChange"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Button,
  Popup,
  Picker
} from 'vant'

export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  props: {
    areaList: {
      type: Array,
      default() {
        return []
      }
    },
    currentArea: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPicker: false
    }
  },
  methods: {
    handleAreaChange(area) {
      this.showPicker = false
      this.$emit('handleAreaChange', area)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .van-button {
    width: 100%;
    .van-button__text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
